/* eslint-disable no-unused-vars */
import { useCallback, useEffect, useState } from 'react'

import { Link, useNavigate, useParams } from 'react-router-dom'

import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '../../Routes/routes'

import HutritIcon from '../../icons/HutritIcon'
import Button from '../Button'
import Notifications from '../Notifications/Notifications'
import useResize from '../../hooks/useResize'
import { userInfo } from '../../localStorage'
import MenuBurgerTwoIcon from '../../icons/MenuBurgerTwoIcon'
import { VIEWPORT_LG } from '../../utils/constants'
import HutritGreenIcon from '../../icons/HutritGreenIcon'
import { useTranslation } from 'react-i18next'
import Translate from './components/Translate'
import SearchTalents from '../SearchTalents'
import MenuBurgerIcon from '../../icons/MenuBurgerIcon'
import { useLandingStore, useNewLandingStore } from '../../store'
import RegisterDropdown from './components/RegisterDropdown'
import FreeConsultationModal from '../../pages/Landing/components/FreeConsultationModal'
import { handleOpenModal } from '../../utils'

const Navbar = ({
  setOpenDrawer = () => {},
  isQuickOffer = false,
  isSuperSearch = false,
  isLanding = false,
  staticNavbar = false,
  renderGreen = true,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { offerManagementId, invitationCode } = useParams()

  const { setFormState } = useNewLandingStore()
  const { typeOfLanding, setTypeOfLanding } = useLandingStore()

  const token = JSON.parse(localStorage.getItem('token'))

  const typeOfUser = userInfo?.payload?.typeUser
  const viewPortSize = useResize()
  const isMobile = viewPortSize[0] <= VIEWPORT_LG

  const [scroll, setScroll] = useState(false)
  const [openUserOptions, setOpenUserOptions] = useState(false)

  const handleNavigation = useCallback(() => {
    setScroll(!window.scrollY <= 0)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', handleNavigation)
    return () => {
      window.removeEventListener('scroll', handleNavigation)
    }
  }, [handleNavigation])

  const handleLogin = () => {
    navigate(PUBLIC_ROUTES.login, {
      state: window.location.pathname,
    })
  }

  const handleGoToRegister = () => {
    navigate(
      offerManagementId && invitationCode
        ? `/register-talent-by-vacancies-link/${invitationCode}`
        : PUBLIC_ROUTES.register_company
    )
  }

  const renderNavbar = isLanding ? (
    <header>
      <FreeConsultationModal />
      <nav
        className={`${staticNavbar ? '' : isMobile ? '' : 'fixed-nav'} navbar`}
        style={{ paddingLeft: '32px', paddingRight: '32px', zIndex: 200 }}
      >
        <div className="d-flex container-fluid w-100 mt-2 mb-2">
          <a className="mt-2 cursor-pointer" onClick={() => setFormState(5)}>
            {viewPortSize[0] <= VIEWPORT_LG ? (
              <HutritGreenIcon fill="#004949" width="78" height="21" />
            ) : isQuickOffer ? (
              <HutritGreenIcon fill="#004949" width="78" height="21" />
            ) : (
              <HutritGreenIcon fill="#004949" width="78" height="21" />
            )}
          </a>
          {isSuperSearch && (
            <div className="d-lg-flex d-none">
              <SearchTalents isSuperSearch={isSuperSearch} />
            </div>
          )}
          {/* {!isSuperSearch && (
            <div
              className="cursor-pointer d-lg-flex d-none"
              onClick={() => navigate('/super-search/')}
              style={{marginLeft: '200px'}}
            >
              <ButtonSuperSearchIcon />
            </div>
          )} */}
          <div
            className="d-lg-none d-flex cursor-pointer"
            onClick={() => setOpenDrawer((prevState) => !prevState)}
          >
            <MenuBurgerIcon />
          </div>

          <div className="d-none d-lg-flex flex-row align-items-center">
            <div className="w-100 d-flex flex-column align-items-center  justify-content-center gap-3">
              <Button
                variant="secondary"
                id="navbar-register-company-link"
                className="buttonSelectLanding text-decoration-none text-on-bg-primary border border-on-bg-primary text-center hero-button-anim"
                onClick={() =>
                  handleOpenModal({ id: 'free-consultation-modal' })
                }
              >
                Agenda una asesoría gratuita
              </Button>
            </div>

            {/* <div className="login d-lg-inline-block  me-4">
              <span
                onClick={handleLogin}
                className="text-on-bg-primary cursor-pointer"
              >
                {t('log_in')}
              </span>
            </div> */}
            {/* TODO: HIDE REGISTER BUTTON FOR LANDING PAGES */}
            {/* {(window.location.pathname !== '/' ||
              window.location.pathname !== PUBLIC_ROUTES.landing_talent ||
              window.location.pathname !== PUBLIC_ROUTES.landing_partners ||
              window.location.pathname !==
                PUBLIC_ROUTES.landing_hutrit_next) && (
              <Button
                id="navbar-register-button"
                className="border-bg-CTA-primary text-bg-CTA-primary border"
                onClick={handleGoToRegister}
                style={{
                  background: 'transparent',
                }}
              >
                {t('sign_up')}
              </Button>
            )}
            {(window.location.pathname === '/' ||
              window.location.pathname === PUBLIC_ROUTES.landing_talent ||
              window.location.pathname === PUBLIC_ROUTES.landing_partners ||
              window.location.pathname ===
                PUBLIC_ROUTES.landing_hutrit_next) && <RegisterDropdown />} */}
            <div className="ms-2">
              <Translate isQuickOffer={isQuickOffer} />
            </div>
          </div>
          <Notifications
            typeOfUser={typeOfUser}
            openUserOptions={openUserOptions}
            setOpenUserOptions={setOpenUserOptions}
            token={token}
            userInfo={userInfo}
          />
        </div>
      </nav>
    </header>
  ) : (
    <header
      className={`${
        window.location.pathname === PRIVATE_ROUTES.talents ? 'mb-2' : ''
      }  ${
        viewPortSize[0] <= VIEWPORT_LG
          ? 'bg-bg-brand-pressed'
          : isQuickOffer
          ? 'bg-on-bg-Tertiary-hover'
          : 'bg-bg-brand-pressed'
      } `}
    >
      <nav
        className={`navbar ${staticNavbar ? '' : 'fixed-nav'} ${
          viewPortSize[0] <= VIEWPORT_LG
            ? 'bg-on-bg-primary'
            : scroll
            ? 'navbar-scroll-bg srollNavbarStyles'
            : 'px-5'
        } ${isMobile ? 'bg-bg-brand-pressed srollNavbarStyles' : ''}`}
      >
        <div className="container-fluid mt-2 mb-2">
          <a
            className={`${
              scroll ? 'fixed-margin-left' : ''
            }  mt-2 cursor-pointer`}
            onClick={() => navigate(PUBLIC_ROUTES.home)}
          >
            {viewPortSize[0] <= VIEWPORT_LG ? (
              <HutritIcon />
            ) : isQuickOffer || staticNavbar ? (
              <HutritGreenIcon />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="79"
                height="23"
                viewBox="0 0 79 23"
                fill="none"
              >
                <path
                  d="M16.7383 21.9275H12.0289V15.7628C9.5919 16.8281 7.1839 16.8341 4.74345 15.7679V21.9139H0.0145045V6.58917H4.72809V7.03475C4.72809 8.58575 4.73577 10.1359 4.72211 11.6869C4.72211 11.9797 4.79552 12.1384 5.07977 12.2588C7.25389 13.1849 10.1587 13.1124 12.0281 12.0659V6.59003H16.7383V21.9275Z"
                  fill="#004949"
                />
                <path
                  d="M30.5939 6.57721H35.2947V21.9156H30.5999V19.884C29.7591 20.9262 28.7936 21.5622 27.6293 21.8831C24.8321 22.6514 22.0681 21.5579 20.7877 19.1678C20.2617 18.1704 19.9874 17.0595 19.9888 15.9318C19.9606 12.9878 19.9794 10.042 19.9794 7.09876V6.59684H24.6742V7.06376C24.6742 9.63822 24.6699 12.2127 24.6742 14.7871C24.6742 15.5759 24.7783 16.3484 25.2572 17.0142C25.9623 17.9924 27.2666 18.3919 28.541 18.0283C29.7036 17.6971 30.4718 16.7359 30.5435 15.453C30.5896 14.6164 30.5854 13.7765 30.5871 12.9382C30.593 10.975 30.5871 9.01168 30.5871 7.0484L30.5939 6.57721Z"
                  fill="#004949"
                />
                <path
                  d="M39.4295 10.4893H37.5763V6.57551H39.4175V2.82906H44.1243V6.55161H47.2254V10.4696H44.1388V16.3424C44.1388 17.5895 44.4615 17.9165 45.6924 17.9165H47.2451V21.9472C45.6027 21.8925 43.9502 22.1247 42.3548 21.5562C40.6356 20.945 39.7223 19.6826 39.5234 17.9088C39.4295 17.062 39.4397 16.2084 39.4295 15.3548C39.4201 13.7509 39.4295 12.1453 39.4295 10.4893Z"
                  fill="#004949"
                />
                <path
                  d="M78.3264 21.948C76.8197 21.8925 75.3114 22.0871 73.833 21.6774C71.9243 21.149 70.7891 19.8362 70.5944 17.8516C70.5159 17.0475 70.5091 16.234 70.5091 15.4248C70.4946 13.803 70.5014 12.1811 70.498 10.5593C70.498 10.5482 70.4818 10.5379 70.4434 10.491H68.6414V6.59003H70.4766V2.83419H75.2235V6.54991H78.2905V10.4765H75.2389V10.9033C75.2389 12.7812 75.2389 14.6591 75.2389 16.537C75.2389 17.5537 75.6059 17.9113 76.6362 17.913H78.3264V21.948Z"
                  fill="#004949"
                />
                <path
                  d="M54.5827 21.9275H49.881V6.58831H54.5852V9.0501C55.8255 7.36765 57.3389 6.40394 59.3859 6.38942V11.4146C58.802 11.4146 58.2361 11.406 57.671 11.4146C57.43 11.4229 57.1902 11.4515 56.954 11.4999C55.4491 11.7944 54.7013 12.6233 54.6236 14.1598C54.575 15.1661 54.5852 16.1768 54.5809 17.1858C54.575 18.6079 54.5809 20.03 54.5809 21.4538L54.5827 21.9275Z"
                  fill="#004949"
                />
                <path
                  d="M66.3487 6.596V21.9156H61.6539V6.596H66.3487Z"
                  fill="#004949"
                />
                <path
                  d="M61.6496 5.18244V0.487639H66.3274V5.18671L61.6496 5.18244Z"
                  fill="#004949"
                />
                <path
                  d="M14.3883 5.18585C13.9218 5.18348 13.4664 5.04317 13.0794 4.78256C12.6925 4.52195 12.3913 4.15271 12.2138 3.7213C12.0362 3.28988 11.9902 2.81559 12.0816 2.35812C12.1731 1.90064 12.3978 1.48043 12.7275 1.15037C13.0572 0.820315 13.4771 0.595166 13.9345 0.503265C14.3919 0.411363 14.8662 0.456817 15.2978 0.633903C15.7294 0.81099 16.099 1.1118 16.36 1.49846C16.621 1.88512 16.7618 2.34035 16.7647 2.80686C16.7674 3.11982 16.7079 3.43019 16.5894 3.71989C16.471 4.00958 16.2961 4.27281 16.0749 4.49423C15.8537 4.71565 15.5907 4.89084 15.3011 5.00958C15.0116 5.12832 14.7013 5.18824 14.3883 5.18585Z"
                  fill="#004949"
                />
                <path
                  d="M2.37385 5.18671C1.90531 5.18839 1.44682 5.05089 1.05654 4.79164C0.66626 4.53238 0.361768 4.16305 0.181685 3.7305C0.00160141 3.29795 -0.0459587 2.82165 0.0450357 2.36203C0.13603 1.90241 0.361479 1.48017 0.692789 1.14886C1.0241 0.817545 1.44634 0.592096 1.90597 0.501102C2.36559 0.410107 2.84188 0.457668 3.27443 0.637751C3.70699 0.817834 4.07631 1.12233 4.33557 1.51261C4.59482 1.90289 4.73233 2.36137 4.73064 2.82991C4.72772 3.45408 4.47848 4.05184 4.03713 4.49319C3.59577 4.93455 2.99801 5.18379 2.37385 5.18671Z"
                  fill="#004949"
                />
              </svg>
            )}
          </a>

          {isSuperSearch && (
            <div className="d-lg-flex d-none">
              <SearchTalents isSuperSearch={isSuperSearch} />
            </div>
          )}
          <div
            className="d-lg-none d-flex cursor-pointer"
            onClick={() => setOpenDrawer((prevState) => !prevState)}
          >
            <MenuBurgerTwoIcon />
          </div>
          {(window.location.pathname === '/' ||
            window.location.pathname === PUBLIC_ROUTES.landing_talent ||
            window.location.pathname === PUBLIC_ROUTES.landing_partners ||
            window.location.pathname === PUBLIC_ROUTES.landing_hutrit_next) &&
            !isMobile && (
              <div
                className="d-flex align-items-center text-white d-none"
                style={{
                  gap: isMobile ? '' : '40px',
                }}
              >
                <span
                  className={`${
                    typeOfLanding === 'company'
                      ? 'buttonSelectLandingFocus'
                      : ''
                  } buttonSelectLanding`}
                  onClick={() => {
                    navigate(PUBLIC_ROUTES.home, {
                      state: PUBLIC_ROUTES.home,
                    })
                    setTypeOfLanding('company')
                  }}
                >
                  {t('im_am_company')}
                </span>
              </div>
            )}
          <div
            className={`${
              scroll ? 'fixed-margin-right' : ''
            } d-none d-lg-flex flex-row align-items-center `}
          >
            <div className="d-flex flex-column align-items-center justify-content-center gap-3">
              <Button
                onClick={() =>
                  handleOpenModal({ id: 'free-consultation-modal' })
                }
                variant="secondary"
                id="navbar-register-company-link"
                className="buttonSelectLanding text-decoration-none text-on-bg-primary border border-on-bg-primary text-center hero-button-anim"
              >
                Agenda una asesoría gratuita
              </Button>
            </div>
            {/* <div className="login d-lg-inline-block  me-4">
              <span
                onClick={handleLogin}
                className={`${
                  isQuickOffer || (staticNavbar && !scroll)
                    ? 'text-white'
                    : scroll
                    ? 'text-on-bg-primary'
                    : 'text-on-bg-primary'
                } cursor-pointer`}
              >
                {t('log_in')}
              </span>
            </div> */}
            {/* {window.location.pathname.includes('/list-of-public-vacancies') ||
              (window.location.pathname.includes('/hutrit-club-videos') && (
                <Button
                  id="navbar-register-button"
                  className={`${
                    isQuickOffer && !scroll
                      ? 'bg-on-bg-Tertiary-hover border-on-bg-primary'
                      : scroll
                      ? 'btn-bg-brand border-bg-CTA-primary text-bg-CTA-primary'
                      : 'btn-bg-brand-pressed border-bg-CTA-primary text-bg-CTA-primary'
                  }`}
                  onClick={handleGoToRegister}
                >
                  {t('sign_up')}
                </Button>
              ))}
            {(window.location.pathname === '/' ||
              window.location.pathname === PUBLIC_ROUTES.landing_talent ||
              window.location.pathname === PUBLIC_ROUTES.landing_partners ||
              window.location.pathname ===
                PUBLIC_ROUTES.landing_hutrit_next) && <RegisterDropdown />} */}
            <div className="ms-5">
              <Translate
                isQuickOffer={isQuickOffer}
                renderGreen={renderGreen}
              />
            </div>
          </div>
        </div>
      </nav>
    </header>
  )

  return renderNavbar
}

export default Navbar
